module.exports = __webpack_public_path__ + "media/images/aloe/logo/nephos-white-bc2464700c50e8e6e5b8142c50e95120.svg";